export const endpoints = {
  query: '/deviceModel/query',
  get: '/deviceModel/:deviceModelId',
}
